import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Customer {
  documentOwner: string;
  id: number;
  name: string;
}

interface CustomersState {
  customers: Customer[];
  isLoading: boolean;
  error: string | null;
}

const initialState: CustomersState = {
  customers: [],
  isLoading: false,
  error: null,
};

const customersSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    setCustomers(state, action: PayloadAction<Customer[]>) {
      state.customers = action.payload;
      state.error = null;
    },
    clearCustomers(state) {
      state.customers = [];
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

export const { setCustomers, clearCustomers, setLoading, setError, clearError } =
  customersSlice.actions;
export default customersSlice.reducer;
